import { render } from "./LogsView.vue?vue&type=template&id=a787e948&ts=true"
import script from "./LogsView.vue?vue&type=script&lang=ts"
export * from "./LogsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__